import { forwardRef, cloneElement } from 'react';
import t from 'styled-components';
import { Content, Arrow, Provider, Root, Trigger, Portal } from '@radix-ui/react-tooltip';
import { jsx, jsxs } from 'react/jsx-runtime';

var w=`
  --background-tooltip: var(--color-neutral-900);
  --foreground-tooltip: var(--color-neutral-0);
  --foreground-tooltip-link: var(--color-blurple-400);
  --foreground-tooltip-link-active: var(--color-blurple-300);
  --foreground-link: var(--foreground-tooltip-link);

[data-theme='dark'] & {
  --background-tooltip: var(--color-neutral-500);
  --foreground-tooltip: var(--color-neutral-50);
  --foreground-tooltip-link: var(--color-blurple-300);
  --foreground-tooltip-link-active: var(--color-blurple-200);
  --foreground-link-active: var(--foreground-tooltip-link-active);
 }
 `,n=t.div`
  display: inline-flex;
`,y={small:"width: 120px;",regular:"width: 200px;",large:"width: 320px;"},l=t(Content)`
  z-index: var(--z-index-300);
`,a=t.div`
  ${w}

  background-color: var(--background-tooltip);
  border-color: var(--background-tooltip);
  border-radius: var(--border-radius-small);
  color: var(--foreground-tooltip);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-small);
  line-height: 1.5;
  padding: var(--spacing-small) var(--spacing-regular);
  text-align: center;
  white-space: normal;

  ${({$size:r})=>r?y[r]:"white-space: nowrap;"}
`,p=t(Arrow)`
  fill: var(--background-tooltip);
`;var s=forwardRef(({children:r,content:g,size:u,defaultOpen:c,disabled:f=!1,open:m,onOpenChange:v,delayDuration:T=300,placement:x,offset:b=5,container:C=document.body,className:e,useChildrenAsTrigger:h=!1,...P},i)=>jsx(Provider,{children:jsxs(Root,{defaultOpen:c,open:f?!1:m,onOpenChange:v,delayDuration:T,...P,children:[jsx(Trigger,{asChild:!0,children:h?cloneElement(r,{ref:i,className:e}):jsx(n,{ref:i,className:e,children:r})}),jsx(Portal,{container:C,children:jsxs(l,{sideOffset:b,side:x,children:[jsx(a,{$size:u,children:g}),jsx(p,{})]})})]})}));s.displayName="Tooltip";var L=t(s)``;

export { L as a };
